
import { ref } from 'vue'

export function useCartAnimation() {
  const createFlyAnimation = (startX, startY) => {
    const shopCar = document.querySelector('.right_fixed_car')
    if (!shopCar) return
    
    const ball = document.createElement('img')
    ball.src = require('../assets/ping.png')
    ball.style.cssText = `
      position: fixed;
      left: ${startX}px;
      top: ${startY}px;
      width: 35px;
      height: 50px;
      z-index: 999;
      will-change: transform;
      transition: 
        left 0.8s cubic-bezier(0.4, -0.3, 0.7, 1.3),
        top 0.8s cubic-bezier(0.4, -0.3, 0.7, 1.3),
        transform 0.8s;
    `
    
    document.body.appendChild(ball)
    
    requestAnimationFrame(() => {
      const endX = shopCar.getBoundingClientRect().left + shopCar.offsetWidth/2 -15
      const endY = shopCar.getBoundingClientRect().top + shopCar.offsetHeight/2-20
      ball.style.left = `${endX}px`
      ball.style.top = `${endY}px`
      ball.style.transform = 'scale(0.3) rotate(15deg)'
    })

    ball.addEventListener('transitionend', () => {
      ball.remove()
      // 可以在这里触发购物车抖动动画
    })
  }

  return { createFlyAnimation }
}
